import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaMoon, FaSun, FaClock, FaHourglassHalf, FaHome, FaBars, FaTimes, FaCode } from 'react-icons/fa';

const FloatingMenu = ({ theme, toggleTheme }) => {
    const [isOpen, setIsOpen] = useState(false);

    const menuVariants = {
        hidden: { opacity: 0, scale: 0.8, y: -20 },
        visible: {
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.2
            }
        },
        exit: {
            opacity: 0,
            scale: 0.8,
            y: -20,
            transition: {
                staggerChildren: 0.05,
                staggerDirection: -1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -20 }
    };

    return (
        <div className="floating-menu-container">
            <motion.button
                className={`floating-fab ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                {isOpen ? <FaTimes /> : <FaBars />}
            </motion.button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="floating-menu-items"
                        variants={menuVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <motion.button
                            variants={itemVariants}
                            className="menu-item theme-toggle"
                            onClick={toggleTheme}
                            aria-label="Toggle Theme"
                        >
                            {theme === 'light' ? <FaMoon /> : <FaSun />}
                            <span className="tooltip">Modu Değiştir</span>
                        </motion.button>

                        <motion.div variants={itemVariants} className="menu-link-wrapper">
                            <Link to="/countdown" className="menu-item" onClick={() => setIsOpen(false)}>
                                <FaHourglassHalf />
                                <span className="tooltip">Geri Sayım</span>
                            </Link>
                        </motion.div>

                        <motion.div variants={itemVariants} className="menu-link-wrapper">
                            <Link to="/pomodoro" className="menu-item" onClick={() => setIsOpen(false)}>
                                <FaClock />
                                <span className="tooltip">Pomodoro</span>
                            </Link>
                        </motion.div>

                        <motion.div variants={itemVariants} className="menu-link-wrapper">
                            <Link to="/developer" className="menu-item" onClick={() => setIsOpen(false)}>
                                <FaCode />
                                <span className="tooltip">Geliştirici</span>
                            </Link>
                        </motion.div>

                        <motion.div variants={itemVariants} className="menu-link-wrapper">
                            <Link to="/" className="menu-item" onClick={() => setIsOpen(false)}>
                                <FaHome />
                                <span className="tooltip">Ana Sayfa</span>
                            </Link>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default FloatingMenu;
